import { getDisplayMessage } from './getDisplayMessage';
import { Helmet } from 'react-helmet';
import { SecondaryButton } from '../../components/forms/buttons';

import React, { useState, useEffect } from "react";
import "../../assets/css/dashboard/dashboard.css";
import { FileExportIcon, InformationCircleIcon } from "hugeicons-react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { LineChart } from "@mui/x-charts/LineChart";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ErrorComponent from '../../components/ErrorComponent/ErrorPage'
import { Timer02Icon, BedIcon, SearchingIcon, WorkoutRunIcon, } from "hugeicons-react";
import DashboardTotalCard from "../../components/dashboard/DashboardTotalCard";
import DashboardContainer from "../../components/dashboard/DashboardContainer";
import api, { API_URL } from "../../api";
import TableLoading from "../../components/loading/TableLoading";
import PageLoading from "../../components/loading/PageLoading";
import { toast } from 'react-toastify';
import { useGlobalData } from '../../services/GlobalDataContext';

const monthToNumber = {
  January: 1, February: 2, March: 3, April: 4, May: 5, June: 6,
  July: 7, August: 8, September: 9, October: 10, November: 11, December: 12,
  YTD: 'ytd'
};



const DashboardContent = () => {

  const { availableYears } = useGlobalData();
  const [measuresDataYear, setMeasuresDataYear] = useState("this_year")
  const [measureBy, setMeasureBy] = useState("ED Mortality Rate");
  const [selectedMonth, setSelectedMonth] = useState("YTD");
  const [selectedYear, setSelectedYear] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [chatData, setChatData] = useState([]);
  const [fetchingPerformanceMeasures, setFetchingPerformanceMeasures] = useState(true);
  const [isLoadingYTD, setIsLoadingYTD] = useState(false);

  const [totalData, setTotalData] = useState({});
  const [emmergencyData, setEmmergencyData] = useState({});
  const [maxEmmergencyData, setMaxEmmergencyData] = useState(0);
  const [measuresList, setMeasuresList] = useState('')
  const [error, setError] = useState(null);
  // availableYears comes from context now
  const [isDashboardLoading, setIsDashboardLoading] = useState(true);
  const [isChartLoading, setIsChartLoading] = useState(false);
  const [isEmergencyLoading, setIsEmergencyLoading] = useState(false);
  const [actualEndMonth, setActualEndMonth] = useState(null);

  const categories = [
    "CENSUS - VOLUME & UTILIZATION",
    "CLINICAL QUALITY",
    "HUMAN RESOURCES"
  ];

  /* fetchPerformanceMeasures function */

  /* fetchTotalsData function */

  /* fetchMeasuresChartData function */

  /* fetchEmergencyData function */

  // Removed local fetchAvailableYears function

  useEffect(() => {
    if (availableYears.length > 0 && selectedYear === null) {
      const currentYear = new Date().getFullYear();
      setSelectedYear(availableYears.includes(currentYear) ? currentYear : availableYears[0]);
    }
  }, [availableYears, selectedYear]);
  const fetchPerformanceMeasures = async (value) => {
    setMeasuresList([]);
    try {
      setFetchingPerformanceMeasures(true);
      const yearParam = value || selectedYear;
      if (selectedMonth === 'YTD') {

        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        let maxMonthWithData = 0;
        let allMeasures = [];
        for (let month = 1; month <= ((Number(yearParam) === currentYear) ? currentMonth : 12); month++) {
          try {
            const response = await api.get(`${API_URL}/dashboard/measures_table_data/`, {
              params: {
                year: yearParam,
                month: month
              }
            });
            if (response.status === 200 && response.data && Array.isArray(response.data.measures) && response.data.measures.length > 0) {
              allMeasures.push(...response.data.measures);
              maxMonthWithData = month;
            }
          } catch (monthError) {

          }
        }

        if (maxMonthWithData > 0) {
          const monthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          setActualEndMonth(monthNames[maxMonthWithData]);
        } else {
          setActualEndMonth(null);
        }

        const measureMap = {};
        allMeasures.forEach(measure => {
          const key = `${measure.name}|${measure.category}`;
          if (!measureMap[key]) {
            measureMap[key] = { ...measure, hospitals: (measure.hospitals || []).map(h => ({ ...h })) };
          } else {

            (measure.hospitals || []).forEach((h, idx) => {
              if (measureMap[key].hospitals[idx]) {
                measureMap[key].hospitals[idx].value = (Number(measureMap[key].hospitals[idx].value) || 0) + (Number(h.value) || 0);
              }
            });
          }
        });

        const uniqueMeasures = new Set(Object.values(measureMap).map(m => m.name));
        if (uniqueMeasures.size > 0) {
          setMeasureBy(uniqueMeasures.values().next().value);
        }
        setMeasuresList([...uniqueMeasures]);

        const groupedData = categories.reduce((acc, category) => {
          acc[category] = Object.values(measureMap).filter(el => el.category === category);
          return acc;
        }, {});
        setTableData(groupedData);
      } else {

        const monthParam = monthToNumber[selectedMonth] || 1;
        const response = await api.get(`${API_URL}/dashboard/measures_table_data/`, {
          params: {
            year: yearParam,
            month: monthParam
          }
        });
        if (response.status === 200) {

          const uniqueMeasures = new Set();
          if (response.data && response.data.measures && Array.isArray(response.data.measures)) {
            response.data.measures.forEach(item => {
              uniqueMeasures.add(item.name);
            });
            if (uniqueMeasures.size > 0) {
              setMeasureBy(uniqueMeasures.values().next().value);
            }
            setMeasuresList([...uniqueMeasures]);

            const groupedData = categories.reduce((acc, category) => {
              acc[category] = response.data.measures.filter(el => el.category === category);
              return acc;
            }, {});
            setTableData(groupedData);
          } else {
            setTableData({});
          }
        } else {
          setTableData({});
        }
      }
      setFetchingPerformanceMeasures(false);
    } catch (error) {
      setFetchingPerformanceMeasures(false);
      setTableData({});
    }
  };

  const fetchTotalsData = async (value) => {
    try {
      if (selectedMonth === 'YTD') {
        setIsLoadingYTD(true);
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;

        let maxMonthWithData = 0;
        let aggregatedData = {
          total_acute: 0,
          total_swing_bed: 0,
          total_observation: 0,
          total_emergency_room: 0
        };

        const endMonth = (Number(value) === currentYear) ? currentMonth : 12;
        for (let month = 1; month <= endMonth; month++) {
          try {
            const response = await api.get(`${API_URL}/dashboard/dashboard_totals/${value}/${month}/`);

            let monthData = (response.status === 200 && response.data[Number(value)]) ? response.data[Number(value)] : {};
            if (monthData.total_acute || monthData.total_swing_bed || monthData.total_observation || monthData.total_emergency_room) {
              aggregatedData.total_acute += monthData.total_acute || 0;
              aggregatedData.total_swing_bed += monthData.total_swing_bed || 0;
              aggregatedData.total_observation += monthData.total_observation || 0;
              aggregatedData.total_emergency_room += monthData.total_emergency_room || 0;
              maxMonthWithData = month;
            }
          } catch (monthError) {

          }
        }
        if (maxMonthWithData > 0 && !actualEndMonth) {
          const monthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          setActualEndMonth(monthNames[maxMonthWithData]);
        }

        setTotalData(aggregatedData);
        setIsLoadingYTD(false);
      } else {

        const monthParam = monthToNumber[selectedMonth] || 1;
        const response = await api.get(`${API_URL}/dashboard/dashboard_totals/${value}/${monthParam}/`);

        if (response.status === 200) {
          setTotalData(response.data[Number(value)]);
        }
      }
    } catch (error) {
      setIsLoadingYTD(false);
      console.error('Error fetching totals data:', error);
    }
  };


  const fetchMeasuresChartData = async (selected_year, measure_by) => {
    setIsChartLoading(true);
    try {
      const year = selected_year;
      const measure = measure_by || "ED Mortality Rate";


      const encodedMeasure = encodeURIComponent(measure);

      const response = await api.get(
        `${API_URL}/dashboard/measures_chart_data/${year}/${encodedMeasure}/`
      );

      if (response.status === 200) {
        setChatData(
          response.data
            .map((data) =>
              data.measures
                .map((measure) =>
                  measure.hospitals.map((hospital) => ({
                    label: hospital.name,
                    data: hospital.months.map(
                      (monthData) => Object.values(monthData)[0]
                    ),
                  }))
                )
                .flat()
            )
            .flat()
        );
      }
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
    setIsChartLoading(false);
  };


  const fetchEmergencyData = async (year, month) => {
    setIsEmergencyLoading(true);
    try {
      const yearToUse = year || selectedYear;
      const monthToUse = month || selectedMonth;

      if (monthToUse === 'YTD') {

        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        const endMonth = (Number(yearToUse) === currentYear) ? currentMonth : 12;

        let aggregatedData = {
          Carnegie: 0,
          Pawhuska: 0,
          Seiling: 0,
          Prague: 0,
          Mangum: 0
        };

        let maxMonthWithData = 0;

        for (let monthNum = 1; monthNum <= endMonth; monthNum++) {
          try {
            const response = await api.get(
              `${API_URL}/dashboard/emergency_rooms_data/${yearToUse}/${monthNum}/`
            );

            let monthData = (response.status === 200 && response.data[yearToUse]?.[monthNum]) ? response.data[yearToUse][monthNum] : {};
            if (monthData.Carnegie || monthData.Pawhuska || monthData.Seiling || monthData.Prague || monthData.Mangum) {
              aggregatedData.Carnegie += Number(monthData.Carnegie) || 0;
              aggregatedData.Pawhuska += Number(monthData.Pawhuska) || 0;
              aggregatedData.Seiling += Number(monthData.Seiling) || 0;
              aggregatedData.Prague += Number(monthData.Prague) || 0;
              aggregatedData.Mangum += Number(monthData.Mangum) || 0;
              maxMonthWithData = monthNum;
            }
          } catch (monthError) {

          }
        }

        if (maxMonthWithData > 0 && !actualEndMonth) {
          const monthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          setActualEndMonth(monthNames[maxMonthWithData]);
        }

        setEmmergencyData(aggregatedData);

        const total = Object.values(aggregatedData).reduce((acc, val) => acc + val, 0);
        setMaxEmmergencyData(total);

      } else {

        const monthNumber = monthToNumber[monthToUse] || 1;
        const response = await api.get(
          `${API_URL}/dashboard/emergency_rooms_data/${yearToUse}/${monthNumber}/`
        );

        if (response.status === 200) {

          if (!response.data[yearToUse]?.[monthNumber]) {
            setEmmergencyData({});
            setMaxEmmergencyData(0);
          } else {
            const monthData = response.data[yearToUse][monthNumber];

            setEmmergencyData(monthData);


            const values = [
              monthData['Carnegie'] || 0,
              monthData['Pawhuska'] || 0,
              monthData['Seiling'] || 0,
              monthData['Prague'] || 0,
              monthData['Mangum'] || 0,
            ].map(val => Number(val) || 0);

            const total = values.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            setMaxEmmergencyData(total);
          }
        }
      }
    } catch (error) {
      setEmmergencyData({});
      setMaxEmmergencyData(0);
    }
    setIsEmergencyLoading(false);
  };



  useEffect(() => {
    if (selectedYear !== null) {
      const loadDashboardData = async () => {
        setIsDashboardLoading(true);

        await fetchPerformanceMeasures();

        await Promise.all([
          fetchTotalsData(selectedYear),
          fetchEmergencyData(selectedYear, selectedMonth),
          fetchMeasuresChartData(selectedYear, measureBy)
        ]);

        setIsDashboardLoading(false);
      };

      loadDashboardData();
    }
  }, [selectedYear, selectedMonth]);

  const handleMeasureBy = (value) => {

    setMeasureBy(value);

  };

  useEffect(() => {
    setIsChartLoading(true);
    fetchMeasuresChartData(selectedYear, measureBy);
  }, [measureBy]);

  const handleSelectedMonth = (value) => {
    setSelectedMonth(value);
  };


  const xLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const handleExport = () => {
    if (!tableData || typeof tableData !== 'object' || Array.isArray(tableData)) {
      return;
    }

    const doc = new jsPDF();
    let startY = 10;

    doc.setFontSize(12);
    doc.text("Performance Measures Report", 105, startY, { align: "center" });
    startY += 5;

    Object.keys(tableData).forEach(category => {
      if (!tableData[category] || tableData[category].length === 0) {
        console.warn(`No data for category: ${category}`);
        return;
      }

      doc.setFontSize(14);
      doc.text(category, 10, startY);
      startY += 5;

      const rows = tableData[category].map(measure => {
        return {
          Measure: measure.name || "-",
          Goal: measure.measure_unit === "percentage" && measure.BM !== undefined
            ? `${measure.BM}%`
            : measure.BM || "-",
          ...Object.fromEntries(
            (measure.hospitals || []).map(hospital => [
              hospital.name,
              hospital.value !== undefined && measure.measure_unit === "percentage"
                ? `${hospital.value}%`
                : hospital.value !== undefined
                  ? hospital.value
                  : "-"
            ])
          )
        };
      });

      if (rows.length === 0) {
        console.warn(`No measures found for category: ${category}`);
        return;
      }

      const headers = [
        { header: "Measure", dataKey: "Measure" },
        { header: "Goal", dataKey: "Goal" },
        ...(tableData[category][0]?.hospitals || []).map(hospital => ({
          header: hospital.name,
          dataKey: hospital.name,
        })),
      ];

      doc.autoTable({
        startY,
        head: [headers.map(header => header.header)],
        body: rows.map(row => headers.map(header => row[header.dataKey] || "-")),
        theme: "grid",
      });

      startY = doc.lastAutoTable.finalY + 5;
    });

    doc.save("performance_measures.pdf");
  };

  const getColor = (index) => {
    const colors = [
      "#FF5733",
      "#33FF57",
      "#3357FF",
      "#FF33A1",
      "#F0A500",
    ];
    return colors[index % colors.length];
  };



  return (
    <div className="dashboard-container">
      {isDashboardLoading ? (
        <PageLoading className="content-loading" />
      ) : (
        <>
          <Helmet>
            <title>Dashboard | KPI Tool</title>
          </Helmet>
          <div className="top-actions">
            <SecondaryButton
              className="export-bttn"
              onClick={handleExport}
              iconClass={<FileExportIcon size={24} />}
              buttonText="Export Table"
            />
            <div className="filter-container">
              <Select className="filter-year-select"
                onChange={(e) => setSelectedYear(e.target.value)}
                name="duration"
                id="duration"
                value={selectedYear}
              >
                {availableYears.length > 0 ? (
                  availableYears.map(year => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                  ))
                ) : (
                  <MenuItem value={selectedYear}>{selectedYear}</MenuItem>
                )}
              </Select>
              <Select
                onChange={(e) => {
                  handleSelectedMonth(e.target.value);
                }}
                name="selectedMonth"
                id="selectedMonth"
                value={selectedMonth}
              >
                <MenuItem value="YTD">YTD (Year-to-Date)</MenuItem>
                <MenuItem value="January">January</MenuItem>
                <MenuItem value="February">February</MenuItem>
                <MenuItem value="March">March</MenuItem>
                <MenuItem value="April">April</MenuItem>
                <MenuItem value="May">May</MenuItem>
                <MenuItem value="June">June</MenuItem>
                <MenuItem value="July">July</MenuItem>
                <MenuItem value="August">August</MenuItem>
                <MenuItem value="September">September</MenuItem>
                <MenuItem value="October">October</MenuItem>
                <MenuItem value="November">November</MenuItem>
                <MenuItem value="December">December</MenuItem>
              </Select>
            </div>
          </div>

          <div className="ytd-indicator">
            {isLoadingYTD ? (
              <> Loading data...</>
            ) : (
              <>{getDisplayMessage(selectedMonth, selectedYear, actualEndMonth)}</>
            )}
          </div>

          <div className="total-hospital-cards">
            <DashboardTotalCard
              className="total-card"
              icon={
                <Timer02Icon size={24} color={"#07AEEF"} variant={"stroke"} />
              }
              value={
                totalData.total_acute ? (
                  <h2>{totalData.total_acute}</h2>
                ) : (
                  <span>No Available Data</span>
                )
              }
              name={"Total Acute"}
            />
            <DashboardTotalCard
              className="total-card"
              icon={<BedIcon size={24} color={"#FFB60A"} variant={"stroke"} />}
              value={
                totalData.total_swing_bed ? (
                  <h2>{totalData.total_swing_bed}</h2>
                ) : (
                  <span>No Available Data</span>
                )
              }
              name={"Total Swingbed"}
            />
            <DashboardTotalCard
              className="total-card"
              icon={
                <SearchingIcon size={24} color={"#FC7D75"} variant={"stroke"} />
              }
              value={
                totalData.total_observation ? (
                  <h2>{totalData.total_observation}</h2>
                ) : (
                  <span>No Available Data</span>
                )
              }
              name={"Total Observation"}
            />
            <DashboardTotalCard
              className="total-card"
              icon={
                <WorkoutRunIcon
                  size={24}
                  color={"#0E76BC"}
                  variant={"stroke"}
                />
              }
              value={
                totalData.total_emergency_room ? (
                  <h2>{totalData.total_emergency_room}</h2>
                ) : (
                  <span>No Available Data</span>
                )
              }
              name={"Total Emergency Room"}
            />
          </div>
          <div className="chart-row">
            <>
              {isChartLoading ? (
                <div>Loading chart...</div>
              ) : (
                <div className="chart-container">
                  <div className="row">
                    <h4>Measure By: </h4>
                    <Select
                      onChange={(e) => {
                        handleMeasureBy(e.target.value);
                      }}
                      name="measureBy"
                      id="measureBy"
                      value={measureBy}
                    >
                      {
                        measuresList.map((measure, index) => (
                          <MenuItem key={index} value={measure} >{measure}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </div>

                  <LineChart
                    height={300}
                    className="chart"
                    series={chatData.map((data, index) => ({
                      data: data.data,
                      label: data.label,
                      color: getColor(index),
                    }))}
                    xAxis={[{ scaleType: "point", data: xLabels }]}
                  />
                </div>
              )}
              {isEmergencyLoading ? (
                <div>Loading emergency data...</div>
              ) : (
                <div className="progress-container">
                  <div className="row hover-container">
                    <h4>Emergency Room Utilization</h4>
                    <div className="hover-info">
                      <InformationCircleIcon color="#CCCCCC" />
                      <div className="hover-description">
                        Percentage of total ER visits across all hospitals. Each percentage represents the proportion of ER visits for each hospital, with the sum totaling 100%.
                      </div>
                    </div>
                  </div>

                  {maxEmmergencyData !== 0 ?

                    <>
                      <div className="hospital-progress">
                        <div className="row">
                          <span className="name">Carnegie</span>
                          <progress
                            value={
                              emmergencyData.Carnegie && maxEmmergencyData > 0
                                ? ((Number(emmergencyData.Carnegie) / maxEmmergencyData) * 100).toFixed(2)
                                : 0
                            }
                            max={100}
                          />
                          <span>
                            {emmergencyData.Carnegie && maxEmmergencyData > 0
                              ? ((Number(emmergencyData.Carnegie) / maxEmmergencyData) * 100).toFixed(2)
                              : 0}
                            %
                          </span>
                        </div>
                        <div className="row">
                          <span className="name">Mangum</span>
                          <progress
                            value={
                              emmergencyData.Mangum && maxEmmergencyData > 0
                                ? ((Number(emmergencyData.Mangum) / maxEmmergencyData) * 100).toFixed(2)
                                : 0
                            }
                            max={100}
                          />
                          <span>
                            {emmergencyData.Mangum && maxEmmergencyData > 0
                              ? ((Number(emmergencyData.Mangum) / maxEmmergencyData) * 100).toFixed(2)
                              : 0}
                            %
                          </span>
                        </div>
                        <div className="row">
                          <span className="name">Pawhuska</span>
                          <progress
                            value={
                              emmergencyData.Pawhuska && maxEmmergencyData > 0
                                ? ((Number(emmergencyData.Pawhuska) / maxEmmergencyData) * 100).toFixed(2)
                                : 0
                            }
                            max={100}
                          />
                          <span>
                            {emmergencyData.Pawhuska && maxEmmergencyData > 0
                              ? ((Number(emmergencyData.Pawhuska) / maxEmmergencyData) * 100).toFixed(2)
                              : 0}
                            %
                          </span>
                        </div>
                        <div className="row">
                          <span className="name">Prague</span>
                          <progress
                            value={
                              emmergencyData.Prague && maxEmmergencyData > 0
                                ? ((Number(emmergencyData.Prague) / maxEmmergencyData) * 100).toFixed(2)
                                : 0
                            }
                            max={100}
                          />
                          <span>
                            {emmergencyData.Prague && maxEmmergencyData > 0
                              ? ((Number(emmergencyData.Prague) / maxEmmergencyData) * 100).toFixed(2)
                              : 0}
                            %
                          </span>
                        </div>
                        <div className="row">
                          <span className="name">Seiling</span>
                          <progress
                            value={
                              emmergencyData.Seiling && maxEmmergencyData > 0
                                ? ((Number(emmergencyData.Seiling) / maxEmmergencyData) * 100).toFixed(2)
                                : 0
                            }
                            max={100}
                          />
                          <span>
                            {emmergencyData.Seiling && maxEmmergencyData > 0
                              ? ((Number(emmergencyData.Seiling) / maxEmmergencyData) * 100).toFixed(2)
                              : 0}
                            %
                          </span>
                        </div>
                      </div>
                    </>
                    :

                    <p>No Data Available</p>

                  }

                </div>

              )}
            </>
          </div>
          <div className="table-container">
            <div className="row">
              <h3>Performance Measures</h3>
            </div>
            {fetchingPerformanceMeasures ? (
              <TableLoading />
            ) : (
              <>
                {(!tableData || Object.keys(tableData).length === 0) ? (
                  <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                    <p>No performance measures data available for the selected period.</p>
                  </div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th>Measures</th>
                        <th className="bm">Goal</th>
                        <th>Carnegie</th>
                        <th>Mangum</th>
                        <th>Pawhuska</th>
                        <th>Prague</th>
                        <th>Seiling</th>
                      </tr>
                    </thead>
                    <tbody>
                      {categories && categories.length > 0 ? categories.map((category) => (
                        <React.Fragment key={category}>
                          <tr>
                            <th colSpan={7} style={{ fontWeight: 'bold', textAlign: 'left', backgroundColor: '#f5f5f5' }} scope="rowgroup">{category}</th>
                          </tr>
                          {tableData && tableData[category] && Array.isArray(tableData[category]) ?
                            tableData[category].map((el, rowIndex) => (
                              <tr key={rowIndex}>
                                <td className="hover-container">
                                  {el.name}
                                  <div className="hover-info">
                                    <InformationCircleIcon color="#CCCCCC" />

                                    <div className="hover-description">
                                      {el.measure_description}
                                    </div>
                                  </div>
                                </td>

                                <td className="bm">{el.BM !== null ? el.BM : "-"} {el.measure_unit === "Percentage" && (el.BM !== null && el.BM !== undefined) ? "%" : ""}</td>
                                {el.hospitals && el.hospitals.length > 0 ? (
                                  el.hospitals.map((hospital, colIndex) => (
                                    <td
                                      key={hospital.name}
                                      className={
                                        (el.BM === null) ? "" :
                                          hospital.value < el.BM && el.value_condition === "Lower is better"
                                            ? "green-bg"
                                            : (hospital.value > el.BM && el.value_condition === "Lower is better")
                                              ? "red-bg"
                                              : (el.BM === null) ? ""
                                                : "yellow-bg"
                                      }
                                    >
                                      {hospital.value !== undefined && hospital.value !== null ? hospital.value : '-'}{el.measure_unit === "Percentage" && hospital.value !== undefined && hospital.value !== null ? "%" : ""}
                                    </td>
                                  ))
                                ) : (
                                  <td colSpan={5}>No hospital data available</td>
                                )}
                              </tr>
                            )) : (
                              <tr>
                                <td colSpan={7}>No data available for {category}</td>
                              </tr>
                            )
                          }
                        </React.Fragment>
                      )) : (
                        <tr>
                          <td colSpan={7}>No categories available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </>
            )}
          </div>
          {error && (
            <ErrorComponent

            />
          )}
        </>
      )}
    </div>
  );
};

const Dashboard = () => {
  return (
    <DashboardContainer content={<DashboardContent />} pageTitle={"Overview"} />
  );
};

export default Dashboard;
